export const DEFAULT_PAGE_HEADER_CENTER_WIDTH = 200
